/* unplugin-vue-components disabled */
export default { 
  mixins: [ModelValue(Boolean)],
  props: {
    label: {
      type: String, default: ''
    },
    description: {
      type: String, default: ''
    }
  }
}
